import React from "react";
import { Modal } from "react-bootstrap";

//import StoragePayment from "./StoragePayment";
import RPStoragePayment from "./RPStoragePayment";

export default class RPPaymentModal extends React.Component {
  componentDidMount() {}

  render() {
    //const { no_of_gb, storage_unit, convenienceCharges } = this.props.fields;
    const {
      no_of_gb,
      storage_unit,
      subscription_id,
      subscription_status,
      sub_start_date,
      sub_end_date
    } = this.props.fields;

    const convenienceCharges = 0.05;

    const gst = 0.18;
    var no_of_months = 1;
    const renewal_flg = this.props.renewal_flg;

    const getMonthsBetweenDates = (startDate, endDate) => {
      let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
      months -= startDate.getMonth();
      months += endDate.getMonth();
      return months <= 0 ? 1 : months;
    };

    if (subscription_status === "ACTIVE") {
      var startDate = new Date(sub_start_date);
      var endDate = new Date(sub_end_date);
      no_of_months = getMonthsBetweenDates(startDate, endDate);
    }

    if (renewal_flg) no_of_months = 12;

    return (
      <Modal
        centered="true"
        show={no_of_gb > 0}
        onHide={(e) => {
          this.props.resetStorage();
        }}
      >
        <Modal.Header closeButton>
          {renewal_flg ? (
            <Modal.Title>Purchase Storage for post Renewal</Modal.Title>
          ) : (
            <Modal.Title>Purchase Storage</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <ul style={{ listStyleType: "none" }}>
            <li>
              <strong>
                Price for {no_of_gb} GB: ₹{no_of_gb * 81} / month
              </strong>
            </li>
            {subscription_id !== 0 ? (
              <li>
                <strong>
                  Total Price for {no_of_gb} GB: ₹{no_of_gb * 81 * no_of_months}{" "}
                  for {no_of_months} Subscription months
                </strong>
              </li>
            ) : (
              ""
            )}
            {subscription_id !== 0 ? (
              <li>
                <strong>
                  Convenience Charges : ₹
                  {parseFloat(
                    no_of_gb * 81 * convenienceCharges * no_of_months
                  ).toFixed(2)}
                </strong>
              </li>
            ) : (
              <li>
                <strong>
                  Convenience Charges : ₹
                  {parseFloat(no_of_gb * 81 * convenienceCharges).toFixed(2)}
                </strong>
              </li>
            )}
            {subscription_id !== 0 ? (
              <li>
                <strong>
                  GST 18% : ₹
                  {parseFloat(
                    (no_of_gb * 81 * no_of_months +
                      no_of_gb * 81 * convenienceCharges * no_of_months) *
                      gst
                  ).toFixed(2)}
                </strong>
              </li>
            ) : (
              <li>
                <strong>
                  GST 18% : ₹
                  {parseFloat(
                    (no_of_gb * 81 + no_of_gb * 81 * convenienceCharges) * gst
                  ).toFixed(2)}
                </strong>
              </li>
            )}
            {subscription_id !== 0 ? (
              <li>
                <strong>
                  Grand Total: ₹{" "}
                  {Math.round(
                    no_of_gb * 81 * no_of_months +
                      no_of_gb * 81 * convenienceCharges * no_of_months +
                      (no_of_gb * 81 * no_of_months +
                        no_of_gb * 81 * convenienceCharges * no_of_months) *
                        gst
                  ).toFixed(2)}
                </strong>
              </li>
            ) : (
              <li>
                <strong>
                  Grand Total: ₹{" "}
                  {Math.round(
                    no_of_gb * 81 +
                      no_of_gb * 81 * convenienceCharges +
                      (no_of_gb * 81 + no_of_gb * 81 * convenienceCharges) * gst
                  ).toFixed(2)}
                </strong>
              </li>
            )}
          </ul>
          {subscription_id !== 0 ? (
            <RPStoragePayment
              no_of_gb={no_of_gb}
              storage_unit={storage_unit}
              no_of_months={no_of_months}
              amount={Math.round(
                no_of_gb * 81 * no_of_months +
                  no_of_gb * 81 * convenienceCharges * no_of_months +
                  (no_of_gb * 81 * no_of_months +
                    no_of_gb * 81 * convenienceCharges * no_of_months) *
                    gst
              ).toFixed(2)}
              renewal_flg={renewal_flg}
              convenienceCharges={convenienceCharges}
            />
          ) : (
            <RPStoragePayment
              no_of_gb={no_of_gb}
              storage_unit={storage_unit}
              no_of_months={1}
              amount={Math.round(
                no_of_gb * 81 +
                  no_of_gb * 81 * convenienceCharges +
                  (no_of_gb * 81 + no_of_gb * 81 * convenienceCharges) * gst
              ).toFixed(2)}
              renewal_flg={false}
              convenienceCharges={convenienceCharges}
            />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}
